<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Partners.modifyInvoicingHeader')"
    width="420px"
    :close-on-click-modal="false"
    append-to-body
    class="invoice-title-select-dialog"
  >
    <div>
      <el-form label-width="90px" label-position="left">
        <el-form-item :label="$t('Payment.settleAccountsTo')">
          <cargo-advance-select
            no="accountIdReadonly"
            filterable
            disabled
            :select-type="selectTypeNames.basic_data_Company"
            :default-value="accountId || ''"
            :method-params="{}"
            options-width="240px;"
            tag-name="chineseName"
          />
        </el-form-item>
        <template v-if="showBeforeAfter">
          <el-form-item :label="$t('CargoMsg.Cargo_BeforeAdjustment')">
            <el-input
              :value="beforeInvoiceTitle"
              disabled
              maxlength="256"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AfterAdjustment')">
            <cargo-advance-select
              no="invoiceTitle"
              filterable
              :filter-tag-names="['title']"
              filter-type="global"
              :default-value="invoiceTitle || ''"
              options-width="240px;"
              tag-value="title"
              tag-name="title"
              :static-options="invoiceTitleList"
              @parentCallBack="onTitleChange"
            />
          </el-form-item>
        </template>
        <el-form-item v-else :label="$t('Payment.invoiceHeader')">
          <cargo-advance-select
            no="invoiceTitle"
            filterable
            :filter-tag-names="['title']"
            filter-type="global"
            :default-value="invoiceTitle || ''"
            options-width="240px;"
            tag-value="title"
            tag-name="title"
            :static-options="invoiceTitleList"
            @parentCallBack="onTitleChange"
          />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button type="primary" no="1" @click="selectOk">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="2" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { queryTitleByCpmIdx } from '@/api/partner/title'

export default {
  name: 'ChangeInvoiceTitleDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    accountId: { type: Number, default: 0 },
    defaultInvoiceTitle: { type: String, default: '' },
    required: { type: Boolean, default: true },
    showBeforeAfter: { type: Boolean, default: false },
    beforeInvoiceTitle: { type: String, default: '' }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      invoiceTitle: '',
      invoiceTitleList: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.invoiceTitle = ''
        this.invoiceTitleList = []
      }
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.onShow()
    }
  },
  methods: {
    async onShow() {
      this.invoiceTitle = this.showBeforeAfter ? '' : (this.defaultInvoiceTitle || '')
      await this.loadInvoiceTitleList()
    },
    async loadInvoiceTitleList() {
      this.invoiceTitleList = []
      if (!this.accountId) {
        return
      }
      const res = await queryTitleByCpmIdx(this.accountId)
      const dbTitles = res.data || []
      this.invoiceTitleList = dbTitles.filter(item => item && item.title)
      if (!this.invoiceTitle && this.invoiceTitleList.length > 0) {
        const defaultTitle = this.invoiceTitleList.find(item => item.defaultTitle === true)
        this.invoiceTitle = (defaultTitle || this.invoiceTitleList[0]).title
      }
    },
    onTitleChange(result) {
      if (result) {
        this.invoiceTitle = result.title || result.value || ''
      }
    },
    selectOk() {
      if (this.required && !this.invoiceTitle) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('Payment.invoiceHeader'))
        return
      }
      this.$emit('changeInvoiceTitle', { invoiceTitle: this.invoiceTitle })
      this.innerVisible = false
    }
  }
}
</script>
